import React from 'react';
import { useResearchContext } from '@/creditflowresearch/application/Research/ResearchContext';
import Paginator from '@creditflowresearch/uilib/Paginator';

const PaginatorContainer = (props) => {
  const {
    paginate,
    researchData: {
      totalCount,
      perPage,
      page,
    },
  } = useResearchContext();
  const onPageChange = ({ selected }) => {
    paginate(selected);
  };

  return (
    <Paginator
      onPageChange={ onPageChange }
      totalCount={ totalCount }
      perPage={ perPage }
      page={ page }
      isItemsPerPageVisible={ false }
      { ...props }
    />
  );
};

export default PaginatorContainer;
